export default "__VITE_ASSET__53a4678a__"